import { useTranslation } from 'react-i18next';

import type { JobStatus } from '@nucleus-commerce/api-client/admin';
import { Badge } from '@nucleus-commerce/ui/components/badge';
import { Tooltip, TooltipContent, TooltipTrigger } from '@nucleus-commerce/ui/components/tooltip';
import { cn } from '@nucleus-commerce/ui/lib/utils';

const TONE: Record<JobStatus, string> = {
  queued: 'border-border text-muted-foreground',
  running: 'bg-primary/10 text-foreground border-transparent',
  completed: 'bg-success/15 text-success border-transparent dark:bg-success/20',
  failed: 'bg-destructive/10 text-destructive border-transparent',
};

/** A failed job carries the worker's error; hovering or focusing the badge shows it. */
export function JobStatusBadge({ status, error }: { status: JobStatus; error?: string | null }) {
  const { t } = useTranslation('importsExports');
  const badge = (
    <Badge variant="outline" className={cn(TONE[status])}>
      {t(`status.${status}`)}
    </Badge>
  );
  if (status !== 'failed' || !error) return badge;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          className="inline-flex cursor-default rounded-full"
          aria-label={t('status.failedWith', { error })}
        >
          {badge}
        </button>
      </TooltipTrigger>
      <TooltipContent>{error}</TooltipContent>
    </Tooltip>
  );
}
